import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Modal, Button, Spinner } from "react-bootstrap";
import { FaVideo, FaCopy, FaExternalLinkAlt } from "react-icons/fa";
import axios from "axios";
import API_ROUTE from "../../utils/apiRoute";

const ZoomLinksModal = ({ isShowing, toggle, reservation }) => {
  const [isOpeningStartUrl, setIsOpeningStartUrl] = useState(false);

  if (!isShowing || !reservation) return null;

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).catch(() => {});
  };

  // Zoom's start_url embeds a short-lived ZAK token, so the one cached at
  // booking time is often expired by the time someone actually starts the
  // meeting. Fetch a fresh one right before opening it.
  const openStartUrl = async () => {
    setIsOpeningStartUrl(true);
    try {
      const res = await axios.get(
        `${API_ROUTE}reservation/zoom-start-url/${reservation._id}`,
        { withCredentials: true }
      );
      const freshUrl = res.data?.data?.startUrl;
      if (freshUrl) {
        window.open(freshUrl, "_blank", "noopener,noreferrer");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsOpeningStartUrl(false);
    }
  };

  return ReactDOM.createPortal(
    <Modal show={isShowing} onHide={toggle} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <FaVideo style={{ marginRight: "0.5rem", color: "#2D8CFF" }} />
          Sessão Zoom
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {reservation.zoomTitle && (
          <div style={{ marginBottom: "1rem" }}>
            <strong>Título:</strong> {reservation.zoomTitle}
          </div>
        )}

        {reservation.zoomStartUrl && (
          <div style={{ marginBottom: "1.2rem", padding: "1rem", backgroundColor: "#fff3cd", borderRadius: "6px", border: "1px solid #ffc107" }}>
            <div style={{ fontWeight: "600", marginBottom: "0.4rem" }}>
              Link anfitrião (não partilhar):
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
              <span style={{ wordBreak: "break-all", fontSize: "0.85rem", flex: 1 }}>
                {reservation.zoomStartUrl}
              </span>
              <Button size="sm" variant="outline-secondary" onClick={() => copyToClipboard(reservation.zoomStartUrl)} title="Copiar link">
                <FaCopy />
              </Button>
              <Button size="sm" variant="outline-primary" onClick={openStartUrl} disabled={isOpeningStartUrl} title="Abrir link (gera link atualizado)">
                {isOpeningStartUrl ? <Spinner size="sm" animation="border" /> : <FaExternalLinkAlt />}
              </Button>
            </div>
            <small style={{ color: "#856404" }}>
              Aceda apenas 5 minutos antes do início da reunião.
            </small>
          </div>
        )}

        {reservation.zoomJoinUrl && (
          <div style={{ marginBottom: "1rem", padding: "1rem", backgroundColor: "#d1ecf1", borderRadius: "6px", border: "1px solid #bee5eb" }}>
            <div style={{ fontWeight: "600", marginBottom: "0.4rem" }}>
              Link para convidados:
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
              <span style={{ wordBreak: "break-all", fontSize: "0.85rem", flex: 1 }}>
                {reservation.zoomJoinUrl}
              </span>
              <Button size="sm" variant="outline-secondary" onClick={() => copyToClipboard(reservation.zoomJoinUrl)} title="Copiar link">
                <FaCopy />
              </Button>
              <Button size="sm" variant="outline-info" href={reservation.zoomJoinUrl} target="_blank" rel="noopener noreferrer" title="Abrir link">
                <FaExternalLinkAlt />
              </Button>
            </div>
          </div>
        )}

        {reservation.zoomPassword && (
          <div style={{ marginBottom: "0.5rem" }}>
            <strong>Senha:</strong> {reservation.zoomPassword}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>Fechar</Button>
      </Modal.Footer>
    </Modal>,
    document.body
  );
};

export default ZoomLinksModal;
